import  axiosClient  from "../axiosClient";



export function getRewards(data){
    let bearerTokenHeader = localStorage.getItem('token');
    axiosClient.defaults.headers.common['Authorization'] = `Bearer ${bearerTokenHeader}`;
    return axiosClient.post('/rewards',JSON.stringify(data));
}
